<!-- AccordionItem.vue -->
<template>
  <div class="accordion-item">
    <div class="accordion-header" @click="toggle" v-show="accordionHeaderState">
      <GiftIcon class="gift" color="#FA9D3B" width="35" />
      <AccordionSkeleton class="skeleton" :isReady="true" v-if="!titleState">
        <template>
        </template>
      </AccordionSkeleton>
      <TextFormatter :text="titleInfo" v-if="titleState"></TextFormatter>&nbsp;
      <ArrowUpIcon class="arrow" v-if="accordionBodyState" width="50" color="rgba(0,0,0,0.9)"
        v-stat.brow.click="{ tag: 'scangift-module.accordion' }" />
      <ArrowDownIcon class="arrow" v-if="!accordionBodyState && titleState" width="50" color="rgba(0,0,0,0.9)"
        v-stat.brow.click="{ tag: 'scangift-module.accordion' }" />
    </div>
    <!--  -->
    <div class="accordion-body" v-show="accordionBodyState">
      <slot name="body"></slot>
    </div>
  </div>

</template>

<script lang="ts" setup>
import { computed, ref } from 'vue-demi';
import TextFormatter from '@tencent/wphk-components-text-formatter/index.vue';
import { ArrowUpIcon, ArrowDownIcon, GiftIcon } from '@tencent/wphk-icon-vue';
import AccordionSkeleton from './addcordion-skeleton.vue';

defineProps<{
  campaignId: string,
}>();

const accordionHeaderState = ref<boolean>(true);
const accordionBodyState = ref<boolean>(false);
const titleInfo = ref<string>('');
const titleState = computed(() => titleInfo.value.length > 0);
// 展开和折叠
const toggle = () => accordionBodyState.value = !accordionBodyState.value;

/* 折叠头部的显示和隐藏 */
const toggleAccordionHeader = (item: boolean) => accordionHeaderState.value = item;
/* 设置折叠头信息 */
const setTitleInfo = (item: string) => titleInfo.value = item;
/* 折叠内容的显示和隐藏 */
const toggleAccordion = (item: boolean) => accordionBodyState.value = item;

defineExpose({
  toggleAccordionHeader,
  toggleAccordion,
  setTitleInfo,
});
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';

.accordion-header {
  display: flex;
  align-items: center;
  border-radius: 16 / @rem;
  width: 686 / @rem;
  height: 80 / @rem;
  font-weight: 500;
  .font-28-regular(#000000); // 字体大小
  text-shadow: 0 / @rem 0 / @rem 10 / @rem rgba(7, 193, 96, 0.05);
  background-color: #fff;

  .gift {
    margin: 0 16 / @rem 4/@rem 24 / @rem;
    width: 28 / @rem;
    height: 29 / @rem;
  }

  .skeleton {
    margin: 0 16 / @rem 0 24 / @rem;
    width: 300 / @rem;
    height: 80 / @rem;
  }

  .arrow {
    margin-left: auto;
    margin-right: 24 / @rem;
  }
}

.accordion-body {
  margin: 18 / @rem 0;
}
</style>
